/**
 * @file Contains some general util functions
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

let pageObjectsMap = new Map();

/**
 * Initialize a map so that each page could utilize the information when constructing these pages
 * Key: the name of the pageObjects
 * Value: the Object that contains page information
 * @param {Array} pageObjects The array that contains information of each page
 */
export const initializePageObjectsMap = (pageObjects) => {
    if (pageObjectsMap.size !== 0) {
        pageObjectsMap.clear();
    }
    pageObjects.forEach((item) => {
        pageObjectsMap.set(item.name, item);
    });
};

export const getPageObjectByName = (pageName) => {
    return pageObjectsMap.get(pageName);
};
